/* eslint-disable no-unused-vars */
/**
 * © [2022] Conduent, Inc. All rights reserved. Conduent®and Conduent Agile
 * Star®are trademarks of Conduent, Inc. and/or its subsidiaries in the United
 * States and/or other countries.
 */
import * as actionTypes from './actionTypes';
//current Quarter
const currentDate = new Date();
const currentMonth = currentDate.getMonth() + 1; // Month is zero-indexed, so add 1
const currentYear = currentDate.getFullYear();
const currentQuarter = Math.ceil(currentMonth / 3); // Divide the current month by 3 and round up to get the current quarter

const formattedQuarter = currentQuarter + 'Q' + currentYear.toString();
const initialState = {
  performResolutionObj: {},
  errorMsgCmsDrug: [],
  startQtr: formattedQuarter,
  quarterlyCms: [],
  displayObj: {
    startQtr: formattedQuarter,
    quarterlyCms: [],
  },
};

export const reducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.GET_CURRENT_DISPLAY_OBJ_DRUG:
      return { ...state, performResolutionObj: action.screenData };
    case actionTypes.GET_ERROR_MSG_CMS_DRUG:
      return { ...state, errorMsgCmsDrug: action.payload };
    case actionTypes.GET_FROM_CMS_DRUG:
      let displayObj1 = {
        ...state.displayObj,
        startQtr: action.payload,
      };
      return { ...state, startQtr: action.payload, displayObj: displayObj1 };
    // return { ...state, startQtr: action.payload };
    case actionTypes.GET_QUARTERLY_CMS_DRUG_DATA:
      let displayObj = {
        ...state.displayObj,
        quarterlyCms: action.payload,
      };
      return { ...state, quarterlyCms: action.payload, displayObj };

    case actionTypes.SET_REFRESH_DATA_DRUG:
      return {
        ...state,
        performResolutionObj: {},
        errorMsgCmsDrug: [],
        startQtr: formattedQuarter,
      };
    case actionTypes.REFRESH_DATA_DRUG_DISPLAY:
      return {
        ...state,
        displayObj: initialState.displayObj,
      };
    default:
      return state;
  }
};

export default reducer;
